<template>
  <div class="page-container">
    <h1 class="page-title">{{ t('pages.contact.info.accordionTitle') }}</h1>
    <div class="content">
      <!-- 第一段内容：文字 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.contact.info.content').split('---')[0]"></p>
        </div>
      </div>
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.contact.info.content').split('---')[1]"></p>
        </div>
      </div>
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.contact.info.content').split('---')[2]"></p>
        </div>
      </div>
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.contact.info.content').split('---')[3]"></p>
        </div>
      </div>
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.contact.info.content').split('---')[4]"></p>
        </div>
      </div>
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.contact.info.content').split('---')[5]"></p>
        </div>
      </div>
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.contact.info.content').split('---')[6]"></p>
        </div>
      </div>
      <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.contact.info.content').split('---')[7]"></p>
        </div>
      </div>
    <div class="content-section">
        <div class="text-block">
          <p v-html="t('pages.contact.info.content').split('---')[8]"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 使用普通JavaScript而不是TypeScript，避免类型错误
import i18n from '../../i18n';
import { computed } from 'vue';
import zhData from '../../i18n/zh';
import enData from '../../i18n/en';
import { useLangStore } from '../../pinia/stores/lang';

export default {
  name: 'ContactInfo',
  setup() {
    // 从i18n实例获取t函数
    const { t } = i18n.global;
    const langStore = useLangStore();
    
    // 根据当前语言选择对应的翻译数据
    const translationData = computed(() => {
      return langStore.currentLang.startsWith('zh') ? zhData : enData;
    });
    
    return {
      t,
      translationData
    };
  }
};
</script>

<style scoped lang="scss">
/* 页面特定样式可以放在这里 */
.page-container {
  overflow: auto;
  max-width: 100%;
  padding: 20px;
  box-sizing: border-box;
  
  @media screen and (max-width: 768px) {
    padding: 10px;
    height: calc(100vh - 120px);
    overflow-y: auto;
  }
  
  .content-section {
    @media screen and (max-width: 768px) {
      margin-bottom: 15px;
    }
    
    .text-block {
      @media screen and (max-width: 768px) {
        font-size: 14px;
        line-height: 1.5;
      }
    }
  }
}
</style> 